import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusApiService } from './status.api';
import { AuthorizationApiService } from '@kempowersw/ngx-authorization-api-client';
import { ConnectionsApiService } from './connections.api';
import { DevicesApiService } from './devices.api';
import { FactoryApiService } from './factory.api';
import { FirmwareApiService } from '@kempoweroyj/ngx-firmware-api-client';
import { LogsApiService } from './logs.api';
import { ChargingStationsApiService } from './charging_stations.api';
import { UpdateRegistryApiService } from '@kempowersw/ngx-update-registry-api-client';
import { FirmwareApprovalApiService } from '@kempowersw/ngx-firmware-approval-api-client';
import { TicketingApiService } from './ticketing.api';
import { LoadBalancingApiService } from '@kempoweroyj/ngx-load-balancing-api-client';
import { OcpiApiService } from './ocpi.api';
import { TariffsApiService } from './tariffs.api';
import { SharingApiService } from './sharing.api';
import { LicensingApiModule, LicensingApiService } from '@kempoweroyj/ngx-licensing-api-client';
import { EnergyPriceApiModule } from '@kempowersw/ngx-energy-price-api-client';
import { LocationsApiModule } from '@kempoweroyj/ngx-locations-api-client';
import { VehiclesApiModule } from '@kempoweroyj/ngx-vehicles-api-client';
import { MaintenanceApiService } from '@kempowersw/ngx-maintenance-api-client';
import { ReportingApiModule } from '@kempoweroyj/ngx-reporting-api-client';
import { SettingsApiModule } from '@kempoweroyj/ngx-settings-api-client';
import { IamUsersApiService } from '@kempowersw/ngx-iam-users-api-client';
import { IamUsersApiService as IamUsersService } from './user.service';
import { IamOrganizationsApiModule, IamOrganizationsApiService } from '@kempoweroyj/ngx-iam-organizations-api-client';
import { EvIdentificationsApiModule, EvIdentificationsApiService } from '@kempowersw/ngx-ev-identifications-api-client';
import { BillingApiService } from '@kempowersw/ngx-billing-api-client';
import { CustomizationApiService } from '@kempowersw/ngx-customization-api-client';
import { TransactionsApiService } from '@kempoweroyj/ngx-transactions-api-client';
import { AssetsApiService } from '@kempowersw/ngx-assets-api-client';
import { CertificatesApiModule } from '@kempowersw/ngx-certificates-api-client';
import { ChargingStationsApiService as ChargingStationsApi } from '@kempoweroyj/ngx-charging-stations-api-client';
import { VirtualChargerApiService } from '@kempoweroyj/ngx-virtual-charger-api-client';
import { EvseApiService } from '@kempoweroyj/ngx-evse-api-client';
import { Ocpp16ApiService } from '@kempowersw/ngx-ocpp16-api-client';
import { HwprofilesApiService } from '@kempowersw/ngx-hwprofiles-api-client';
import { OcppGatewayApiModule } from '@kempowersw/ngx-ocpp-gateway-api-client';
import { SharingApiService as SharingApiClient } from '@kempowersw/ngx-sharing-api-client';
import { ErrorCodesApiService } from '@kempoweroyj/ngx-error-codes-api-client';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        LicensingApiModule,
        EnergyPriceApiModule,
        LocationsApiModule,
        VehiclesApiModule,
        ReportingApiModule,
        IamOrganizationsApiModule,
        EvIdentificationsApiModule,
        SettingsApiModule,
        CertificatesApiModule,
        OcppGatewayApiModule,
    ],
    exports: [],
    providers: [
        AuthorizationApiService,
        ConnectionsApiService,
        DevicesApiService,
        EvseApiService,
        FactoryApiService,
        FirmwareApiService,
        LogsApiService,
        MaintenanceApiService,
        ChargingStationsApiService,
        StatusApiService,
        TransactionsApiService,
        BillingApiService,
        UpdateRegistryApiService,
        FirmwareApprovalApiService,
        TicketingApiService,
        LoadBalancingApiService,
        OcpiApiService,
        TariffsApiService,
        SharingApiService,
        IamUsersApiService,
        IamUsersService,
        IamOrganizationsApiService,
        EvIdentificationsApiService,
        BillingApiService,
        AssetsApiService,
        CustomizationApiService,
        LicensingApiService,
        ChargingStationsApi,
        VirtualChargerApiService,
        Ocpp16ApiService,
        HwprofilesApiService,
        SharingApiClient,
        ErrorCodesApiService,
    ],
})
export class CeApiModule {}
